import type { ShadowingSegment, SubtitleCue } from './types';

export function buildSegment(
  cues: SubtitleCue[],
  startCueIndex: number,
  endCueIndex: number,
): ShadowingSegment {
  if (!Number.isInteger(startCueIndex) || startCueIndex < 0 || startCueIndex >= cues.length) {
    throw new RangeError('Invalid segment start cue index');
  }
  if (!Number.isInteger(endCueIndex) || endCueIndex < 0 || endCueIndex >= cues.length) {
    throw new RangeError('Invalid segment end cue index');
  }
  if (startCueIndex > endCueIndex) {
    throw new RangeError('Segment start must not be after its end');
  }

  return {
    startCueIndex,
    endCueIndex,
    startTime: cues[startCueIndex].start,
    endTime: cues[endCueIndex].end,
  };
}
